// extracted by mini-css-extract-plugin
module.exports = {"container":"cds-checkout_container__2oq7E"};